import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";

import messages from "../../../assets/locale/messages";
import { UIActionModal } from "../../ui";
import { fillTemplate } from "../../Events/Form/Steps/ChooseCrewSize/crewSizeUtils";
import CompanyStatusWarning from "../CompanyStatusWarning";

/** "Activate Company": the Super Admin confirms bringing a deactivated company back. */
const ActivateCompanyModal = ({ company, saving, onClose, onConfirm }) => {
  const lang = useSelector((state) => state.locale.lang);
  const t = messages[lang].companiesList.activation;

  const companyName =
    (lang === "ar" ? company.name_ar : company.name_en) ||
    company.name_en ||
    company.name_ar;

  return (
    <UIActionModal
      open
      maxWidth="xs"
      title={t.title}
      onClose={() => !saving && onClose()}
      actions={
        <UIActionModal.Actions
          cancelLabel={t.cancel}
          confirmLabel={t.confirm}
          confirmLoading={saving}
          onCancel={() => !saving && onClose()}
          onConfirm={onConfirm}
        />
      }
    >
      <UIActionModal.Divider />
      <Typography component="p" className="ui-action-modal__body-text text-center">
        {fillTemplate(t.message, { company: companyName })}
      </Typography>
      <CompanyStatusWarning variant="warning" title={t.warningTitle} items={t.warnings} />
    </UIActionModal>
  );
};

ActivateCompanyModal.propTypes = {
  /** The companies-list row being activated. */
  company: PropTypes.shape({
    name_en: PropTypes.string,
    name_ar: PropTypes.string,
  }).isRequired,
  /** The activation is being sent: the modal can't be confirmed or closed meanwhile. */
  saving: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

ActivateCompanyModal.defaultProps = {
  saving: false,
};

export default ActivateCompanyModal;
